<template>
    <div class="logo">
        <img src="../../assets/img/Springter_Logo_Color_RGB-21.svg" alt="Logo Springter" v-if="type == 'regular'" />
        <img src="../../assets/img/Forward_Manual_v3-24.svg" alt="Logo Springter" v-else-if="type == 'white'" />
    </div>
</template>

<script>
export default {
  name: 'logo',
  props: ['type'],
};
</script>

<style lang="scss">
    .logo{
        width: 250px;
        padding: 12px;
        margin: -3px;

        @include mq('phablet', 'max') {
            width: 40%;
            padding: 0;
        }

        @include mqlandscape(){
            width: 40%;
            padding: 0;
        }
    }
    
</style>




// WEBPACK FOOTER //
// src/components/shared/Logo.vue